import { S as Swiper } from './swiper-core-BXF75Fx2.js';
import { N as Navigation } from './navigation-BvT7k6pb.js';
import { A as Autoplay } from './autoplay-CsPtyn3v.js';
import './create-element-if-not-defined-BFxMbgz9.js';

/**
 * Custom element for displaying promotional products as a Swiper carousel.
 * Initializes Swiper slider with configurable options.
 */
class PromotionalSlider extends HTMLElement {
  /**
   * Lifecycle method called when the element is added to the DOM.
   */
  connectedCallback() {
    this.init();
  }

  /**
   * Initialize the promotional slider.
   */
  init() {
    this.initSwiper();
  }

  /**
   * Get navigation configuration for Swiper.
   * @returns {Object}
   */
  getNavigationConfig() {
    const nextBtn = this.querySelector('.swiper-button-next');
    const prevBtn = this.querySelector('.swiper-button-prev');
    return {
      nextEl: nextBtn,
      prevEl: prevBtn,
    };
  }

  /**
   * Get autoplay configuration for Swiper.
   * @param {Element} swiperEl
   * @returns {Object|false}
   */
  getAutoplayConfig(swiperEl) {
    const autoplay = swiperEl?.dataset.autoplay === 'true';
    const delay = parseInt(swiperEl?.dataset.autoplayDelay) || 5000;

    if (!autoplay) return false;

    return {
      delay,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    };
  }

  /**
   * Initialize Swiper for promotional slider.
   */
  initSwiper() {
    const swiperEl = this.querySelector('.swiper--promotional');

    if (!swiperEl) {
      console.warn('Promotional slider: Swiper element not found');
      return;
    }

    const showNavigation = swiperEl?.dataset.showNavigation === 'true';
    const loop = swiperEl?.dataset.loop === 'true';

    const navigation = this.getNavigationConfig();
    const autoplay = this.getAutoplayConfig(swiperEl);

    const swiperOptions = {
      modules: [Navigation, Autoplay],
      spaceBetween: 16,
      slidesPerView: 1,
      watchOverflow: true,
      navigation: showNavigation ? navigation : false,
      autoplay,
      loop,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
      },
    };

    try {
      const swiper = new Swiper(swiperEl, swiperOptions);
      // Store swiper instance for potential future reference
      this.swiper = swiper;
    } catch (error) {
      console.error('Error initializing Promotional Slider:', error);
    }
  }

  /**
   * Destroy the Swiper instance when element is removed.
   */
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('promotional-slider', PromotionalSlider);
